import { getFirebase } from '../../firebase';
import { AppThunk } from '../store';

export const signOutAction = (): AppThunk => async _ => {
  await getFirebase().auth().signOut();
};
